/**
 * @param {(string[]|Set<string>)} [categories] - when absent, every element
 *   counts as consented, whatever categories it declares
 *
 * @returns {function(Element): boolean}
 */
export default function makeIsConsented(categories) {
  if ( !categories ) {
    return () => true
  }

  const consentedCategories = new Set(categories)

  return (node) => {
    return node.dataset.categories
      .split(',')
      .some((category) => consentedCategories.has(category))
  }
}
